import { render } from "./PanelEdicionProductos.vue?vue&type=template&id=45f9291e&scoped=true"
import script from "./PanelEdicionProductos.vue?vue&type=script&lang=js"
export * from "./PanelEdicionProductos.vue?vue&type=script&lang=js"

import "./PanelEdicionProductos.vue?vue&type=style&index=0&id=45f9291e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f9291e"]])

export default __exports__